import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import VendorProfile from "./Pages/VendorProfile";
import NotFound404 from "./Pages/NotFound404";

// Centralized store URLs
const STORE_URLS = {
  android: "https://play.google.com/store/apps/details?id=com.mycompany.tacos",
  ios: "https://apps.apple.com/pk/app/wknd-app/id6736915994",
};

// Device detection function
function detectDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Check for iOS devices (iPhone, iPad, iPod)
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  }
  
  // Check for Mac (macOS)
  if (/macintosh|mac os x/.test(userAgent)) {
    return 'ios';
  }
  
  // Check for Android
  if (/android/.test(userAgent)) {
    return 'android';
  }
  
  // Check for Windows
  if (/windows/.test(userAgent)) {
    return 'android';
  }
  
  // Check for Linux (redirect to Android store)
  if (/linux/.test(userAgent)) {
    return 'android';
  }
  
  // Default to Android for unknown devices
  return 'android';
}

// Redirect component
function RedirectToStore({ platform }) {
  useEffect(() => {
    if (platform && STORE_URLS[platform]) {
      window.location.href = STORE_URLS[platform];
    }
  }, [platform]);

  return <NotFound404 />;
}

// Handles routing logic
function SmartRouteHandler() {
  const { pathname, search } = useLocation();
  
  // Auto-detect device and redirect to appropriate store
  const devicePlatform = detectDevice();

  // Vendor params in query
  const hasVendorParams =
    search.includes("vendor_profiles_id") && search.includes("userId");

  if (hasVendorParams) return <VendorProfile />;

  // Check if path looks like `/something/number`
  const pathSegments = pathname.split("/").filter(Boolean);
  if (pathSegments.length === 2) return <VendorProfile />;

  // If no vendor-specific route, redirect to store based on device
  return <RedirectToStore platform={devicePlatform} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Root path and wildcard both handled by SmartRouteHandler */}
        <Route path="/" element={<SmartRouteHandler />} />
        <Route path="*" element={<SmartRouteHandler />} />

        {/* Explicit vendor endpoints */}
        <Route
          path="/vendors/get_vendors_details"
          element={<VendorProfile />}
        />
        <Route path="/get_vendors_details" element={<VendorProfile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;